import { useSelector, useDispatch } from 'react-redux';
import { timeBucketActions } from '../../store';
import React, { useEffect } from 'react';

import TimeBucketCategory from './TimeBucketCategory';


const TimeBucket = () => {
  const dispatch = useDispatch();
  const categories = useSelector(state => state.timeBucket.timeBucketCategories.data);

  useEffect(async () => {
    await dispatch(timeBucketActions.getTimeBucketCategories());
  }, []);

  return (
    <>
      {categories.map((category, index) => (
        <TimeBucketCategory category={category} key={index} />
      ))}
    </>
  );
};

export default TimeBucket;